import {Component, EventEmitter, Input, Output} from "@angular/core";
import {MatExpansionModule} from "@angular/material/expansion";
import {
  Application,
  CreateApplicationNoteFn,
  DeleteWebServicesFn,
  DownloadCreditorWatchReportFn,
  DuplicatedApplication,
  GetApplicationByIdFn,
  GetApplicationCreditFlowResultFn,
  GetApplicationDscrFn,
  GetCreditAuditLogFn,
  GetCreditWebServicesFn,
  GetDuplicatedApplicationsFn,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
  GetUserFn,
  RemoveApplicationNoteByNoteIdFn,
  RequestMoreInformationFn,
  RunCreditFlowFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  UpdateCreditStatusFn,
  User,
  isAdminOrCreditUser,
  isInternalUser,
  NewWebService
} from "@portal-workspace/grow-shared-library";
import { CreditOverviewComponent } from '../../credit-component/credit-overview.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { NgTemplateOutlet } from '@angular/common';
import { getUser } from "../../component-utils";
import { GetNotesByApplicationIdFn } from "../../asset-listing-component/notes.component";
import { GetApplicationAuditLogsFn } from "../../asset-listing-component/audit-log.component";

@Component({
  selector: 'consumer-credit',
  templateUrl: './consumer-credit.component.html',
  styleUrls: ['./consumer-credit.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    CreditOverviewComponent,
    MatTabsModule, MatCardModule, NgTemplateOutlet
  ],
})
export class ConsumerCreditComponent {

  @Input({required: true}) application!: Application;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Output() viewReport: EventEmitter<NewWebService> = new EventEmitter();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  isInternalUser = isInternalUser;
  isAdminOrCreditUser = isAdminOrCreditUser;
  loggedInUser: User | null = getUser();

  onViewReport(element: NewWebService) {
    this.viewReport.emit(element)
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
